const flipCards = () => {
  const cards = document.querySelectorAll('.flip-card-inside');
  const cardOverlay = document.querySelector('.flip-card-overlay');

  if (cards.length) {




    cards.forEach((card, index)=>{




      const cloneElem = card.cloneNode(true);
      cloneElem['classList'].add('cloned-element');
      card.after(cloneElem);

      const cardFront = card.querySelector('.flip-card__face--front');
      const closeIcon = card.querySelector('.flip-card__face--close');
      
      cardFront.addEventListener( 'click', () => {
        card.classList.add('is-flipped');
        cardOverlay.classList.add('flip-card-overlay-active');

        let offset

        const mobileBreakpoint = window.matchMedia("(max-width: 767px)");

        switch (index) {
          case 0:
          case 9:
            offset = -150
            break;
          case 1:
            offset = -40
            break;
          case 2:
            offset = -170
            break;
          case 3:
          case 7:
            offset = -190
            break;
          case 4:
            offset = -180
            break;
          case 5:
          case 10:
            offset = -235
            break;
          case 6:
          case 8:
          case 12:
            offset = -60
            break;
          case 11:
          case 14:
            offset = -195
            break;
          case 13:
            offset = -155
            break;
          default:
            offset = -110
            break;
        }

        if (mobileBreakpoint.matches)  {
          offset = -110
        }
        
        const y = card.getBoundingClientRect().top + window.pageYOffset + offset;
        window.scrollTo({ top: y, behavior: 'smooth' });
      })

      closeIcon.addEventListener( 'click', function() {
        card.classList.remove('is-flipped');
        cardOverlay.classList.remove('flip-card-overlay-active');
      })


      // document.addEventListener('click', function(event) {
      //   var isClickInside = card.contains(event.target);
      //   console.log()
      //   if (!isClickInside) {
      //     card.classList.remove('is-flipped');
      //     cardOverlay.classList.add('flip-card-overlay-active');
      //   }
      // });

    })
  }
}

flipCards();
